import notification from 'antd/lib/notification'
import useService from 'Hooks/use-service'
import { ProjectFeatureFlags } from 'HTTPClients/projects.client'
import { useEffect } from 'react'
import { getFeatureFlagsByProjectId } from 'Services/projects.service'

export const useFeatureFlags = (projectId?: string, stepId?: string) => {
    const { data, isLoading, error, trigger } = useService<
        ProjectFeatureFlags,
        { projectId: string; stepId?: string }
    >(getFeatureFlagsByProjectId)

    useEffect(() => {
        if (projectId) {
            trigger({
                projectId,
                stepId,
            })
        }
    }, [trigger, projectId, stepId])

    useEffect(() => {
        if (error) {
            notification.error({
                message: (error as Error).message ?? 'Error in loading feature flags',
                description:
                    'Please try again. If you still face the issue, reach out to the project owner',
                placement: 'bottomLeft',
            })
        }
    }, [error])

    return { data: data?.feature_flags, isLoading, error }
}
